module.exports = __webpack_public_path__ + "static/whyUsTransformation-5f69e81b8d5979abfd1288dcdc064624.png";